import React from 'react'
import '../Styles/DeafCampPage3.scss';
import line from "../Images/Asset 1.png"
import { Link } from 'react-router-dom';

function DeafCampPage3() {
   return (
      <div className="deafCampPage3Content">
         <div className="deafCampPage3Container">
            <div className="deafCampPage3Heading">
               Registration Information
            </div>
            <div className="deafCampPage3HeadingSubtext">
               Register for Camp Online in Three Simple Steps!
            </div>
            <div className="deafCampPage3Numbers">
               <div className="regNumber1">
                  <h1 className="regNumber">1<br></br></h1>

                  <h4 className="regText">     Sign Up for or Sign <br></br>
                     Into An Individual Account<br></br></h4>
               </div>
               <div className="arrowOne">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="regNumber2">
                  <h1 className="regNumber"> 2    <br></br></h1>
                  <h4 className="regText">Select "Register <br></br>
                     for a new event"</h4>
               </div>
               <div className="arrowTwo">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="regNumber3">
                  <h1 className="regNumber">3<br></br></h1>
                  <h4 className="regText">Fill out and submit <br></br>
                     your registration <br></br>
                     information</h4>
               </div>
               <div className="arrowThree">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="deafCampPage3RegisterButton">
                  Register

                  <Link to={"/selectregistration"}>
                     <button>Register
                     </button>
                  </Link>
               </div>

            </div>

         </div>

      </div>
   )
}
export default DeafCampPage3;